import { breakpoints, Dialog, Spacer, Body } from '@spritz-finance/ui'
import styled from 'styled-components'
import { Column } from '../../../../../../components/Layout/Column'
import { Row } from '../../../../../../components/Layout/Row'
import { ContentContainer } from '../../../../../spritzCard/components'

const LiWrapper = styled.li`
    margin-bottom: 24px;
`

const StyledContentWrapper = styled(ContentContainer)`
    max-height: 500px;
    overflow: scroll;
    ${breakpoints.xsmall} {
        max-height: unset;
        overflow: unset;
    }
`

export const SmartPayInfoDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <Dialog.Content contentPadding={false} minWidth={560} style={{ minHeight: 200 }}>
                <Dialog.Title>SMARTPay</Dialog.Title>
                <StyledContentWrapper>
                    <Spacer height={16} />

                    <Row align="center">
                        <Column align="center">
                            <Spacer height={16} />
                            <Body.SmBold align="center">
                                Make recurring payments to your bills with SMARTPay
                            </Body.SmBold>
                        </Column>
                    </Row>

                    <Spacer height={32} />
                    <Row>
                        <Body.Reg size={16}>
                            SMARTPay lets you schedule monthly, automatic blockchain payments ahead
                            of time when you pay with USDC on the Polygon network! Set any bill to a
                            fixed schedule with monthly payments that are sent on your terms: just
                            pick the date you want the bill to be paid, set the amount, and select
                            how many months you would like the payment to repeat.
                        </Body.Reg>
                    </Row>

                    <Spacer height={8} />
                    <ul>
                        <LiWrapper>
                            Once you set up a recurring payment, you can sit back and relax, no need
                            to sign transactions later on.
                        </LiWrapper>
                        <LiWrapper>
                            You will need to have the payment amount in your wallet for each
                            scheduled payment. You'll also need a little bit of Matic in your wallet
                            to cover fees. Learn more about our fees structure here.
                        </LiWrapper>
                        <LiWrapper>
                            You won't pay gas fees on SMARTPay plans. That's right, we'll pick up
                            the tab!
                        </LiWrapper>
                        <LiWrapper>
                            You can’t make edits to a SMARTPay payment once you set it up. If you’d
                            like to make changes, you’ll have to cancel the payment and set it up
                            again with the new specifications.
                        </LiWrapper>
                        <LiWrapper>
                            If you’d like to make changes, you’ll have to cancel the payment and set
                            it up again with the new specifications. If you'd like to cancel future
                            payments, just click on the three dots to the right of your bill account
                            name in the Pay tab, and choose “cancel SMARTPay subscription” to cancel
                            future payments.
                        </LiWrapper>
                    </ul>
                    <Spacer height={32} />
                </StyledContentWrapper>
            </Dialog.Content>
        </Dialog>
    )
}
